import { createSelector } from 'reselect';

import { clientsSelector } from '../../../userData/store/selectors';

export const clientsToChooseFromSelector = createSelector(
  clientsSelector,
  clients => ([
    { value: '-1', label: 'All' },
    ...clients.map(({ clientId, name }) => ({ value: String(clientId), label: name })),
  ])
);
